import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgIdleModule } from '@ng-idle/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { ConfigService } from './services/infrastructure/config.service';
import { SharedDataService } from './services/infrastructure/shared-data.service';
import { CookieService } from './services/infrastructure/cookie.service';
import { NetworkService } from './services/infrastructure/network.service';
import { DashboardService } from './services/seed/dashboard.service';
import { BroadcastService } from './services/infrastructure/broadcaster.service';
import { CommonService } from './services/common/common.service';
import { ExcelService } from './services/infrastructure/excel.service';
import { LocalStorageService } from './services/infrastructure/local-storage.service';
import { DealerService } from './services/seed/dealer.service';
import { GrowerOrderService } from './services/seed/growerOrder.service';
import { LoaderService } from './services/infrastructure/loader.service';
import { SliderModelService } from './services/infrastructure/sliderModel.service';
import { UserSecurityService } from './services/common/user-security.service';
import { SeedFulfillmentService } from './services/seed/seed-fulfillment.service';
import { LineItemAvailabilityService } from './services/seed/reports/line-item-availability.service';
import { OrderTransferService } from './services/seed/order-transfer.service';
import { GrowerDealerAuditService } from './services/seed/reports/grower-dealer-audit.service';
import { TotalOrderSummaryService } from './services/seed/reports/total-order-summary.service';
import { PrePayService } from './services/common/pre-pay.service';
import { ReleaseItemsAuditService } from './services/seed/reports/release-items-audit.service';
import { CppService } from './services/cpp/cpp.service';
import { CppManageSubscription } from './services/cpp/cpp-price-list-manage-subscription.service';
import { CppPriceListService } from './services/cpp/cpp-price-list.service';
import { LicensingService } from './services/seed/licensing.service';
import { SeedReturnService } from './services/seed/seed-return.service';
import { SeedCropLossService } from './services/seed/seed-crop-loss/seed-crop-loss.service';
import { SubscriptionManagementService } from './services/subscription-management/subscription-management.service';
import { CppPricingReportManageSubscription } from './services/cpp/cpp-pricing-report-manage-subscription.service';
import { AssociateCropService } from './services/seed/associate-crop.service';


// Application Components
import { SharedModule } from './common/shared/shared.module';
import { ClickOutSideModule } from './common/directive/clickoutside/clickoutside.module';
import { NumberOnlyDirective } from './common/directive/number.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingDataComponent } from './modules/seed/order/dashboard/landing-data.component';
import { GrowerOrderDetailComponent } from './modules/seed/order/grower/grower-order-details/grower-order-details.component';
import { DealerOrderViewComponent } from './modules/seed/order/dealer-order-view/dealer-order-view.component';
import { ConfirmDialogComponent } from './common/components/confirm-dialog/confirm-dialog.component';
import { ProductAddComponent } from './common/components/product-add/product-add.component';
import { OrderViewComponent } from './modules/seed/order/order-view/order-view.component';
import { GrowerOrderAddComponent } from './modules/seed/order/grower/grower-order-add/grower-order-add.component';
import { AddEditOrderDetailComponent } from './modules/seed/order/grower/add-edit-order/add-edit-order.component';
import { ProductChangeComponent } from './common/components/product-change/product-change.component';
import { GrowerOrderTransferComponent } from './common/components/grower-order-transfer/grower-order-transfer.component';
import { DealerOrderTransferComponent } from './common/components/dealer-order-transfer/dealer-order-transfer.component';
import { UserSecurityComponent } from './modules/common/user-security/user-security.component';
import { efulfillmentTableComponent } from './common/components/efulfillmentTable/efulfillmentTable.component';
import { efulfillmentfilterComponent } from './common/components/efulfillment-filter/efulfillment-filter.component';
import { CreateEditSeedFulfillmentComponent } from './modules/seed/fullfillment/create-edit-seed-fulfillment/create-edit-seed-fulfillment.component';
import { LandingSeedFulfillmentComponent } from './modules/seed/fullfillment/landing-seed-fulfillment/landing-seed-fulfillment.component';
import { GrowerSearchComponent } from './common/components/grower-search/grower-search.component';
import { GrowerAddComponent } from './common/components/grower-add/grower-add.component';
import { GrowerLandingComponent } from './modules/seed/order/grower-tab/grower-landing.component';
import { LogoutComponent } from './modules/common/logout/logout.component';
import { ItemAvailabilityComponent } from './modules/seed/report/item-availability/item-availability.component';
import { QuickOrderSearchComponent } from './modules/seed/report/quick-order-search/quick-order-search.component';
import { ReportDashboardComponent } from './modules/seed/report/report-dashboard/report-dashboard.component';
import { ItemAvailabilityDetailComponent } from './common/components/item-availability-detail/item-availability-detail.component';
import { GrowerOrderAuditComponent } from './modules/seed/report/grower-order-audit/grower-order-audit.component';
import { DealerOrderAuditComponent } from './modules/seed/report/dealer-order-audit/dealer-order-audit.component';
import { DialogComponent } from './common/components/dialog/dialog.component';
import { UnAuthorizeComponent } from './modules/common/unauth/unauthorize.component';
import { EmulationDashboardComponent } from './modules/seed/emulation/emulation-dashboard/emulation-dashboard.component';
import { TotalOrderSummaryComponent } from './modules/seed/report/total-order-summary/total-order-summary.component';
import { NewPrePayRequestComponent } from './modules/common/prepay/new-prepay-request/new-prepay-request.component';
import { EditPrePayRequestComponent } from './modules/common/prepay/edit-prepay-request/edit-prepay-request.component';
import { PrepayContractComponent } from './modules/common/prepay/prepay-contract/prepay-contract.component';
import { PrepayLandingComponent } from './modules/common/prepay/prepay-landing/prepay-landing.component';
import { CustomCurrencyPipe } from './common/pipe/custom-currency.pipe';
import { customCurrencyDirective } from './common/directive/custom-currency.directive';
import { DiffDealerGrowerOrderTransferComponent } from './common/components/diff-dealer-grower-order-transfer/diff-dealer-grower-order-transfer.component';
import { DecimalNumberDirective } from './common/directive/decimal-number.directive';
import { ReleaseItemsAuditComponent } from './modules/seed/fullfillment/release-items-audit/release-items-audit.component';
import { ShippableProductsReportComponent } from './modules/seed/report/shippable-products-report/shippable-products-report.component';
import { CppLandingComponent } from './modules/cpp/cpp-landing/cpp-landing.component';
import { CppCreateOrderComponent } from './modules/cpp/cpp-create-order/cpp-create-order.component';
import { CppAddProductComponent } from './modules/cpp/cpp-common-components/cpp-add-product/cpp-add-product.component';
import { CppAddProductSliderModelService } from './modules/cpp/cpp-common-components/cpp-add-product/cpp-add-product-slider-model.service';
import { CPPFilterComponent } from './modules/cpp/cpp-common-components/cpp-filter/cpp-filter.component';
import { SeedReturnFilterComponent } from './common/components/seed-return-filter/seed-return-filter.component';
import { CppOrderSummaryComponent } from './modules/cpp/cpp-order-summary/cpp-order-summary.component';
import { CppGridViewComponent } from './modules/cpp/cpp-common-components/cpp-grid-view/cpp-grid-view.component';
import { CppErrorOrderMaintenanceComponent } from './modules/cpp/cpp-error-order-maintenance/cpp-error-order-maintenance.component';
import { CppBusinessRuleAnalysisDialogComponent } from './modules/cpp/cpp-common-components/cpp-business-rule-analysis-dialog/cpp-business-rule-analysis-dialog.component';
import { CppErrorOrderMaintenanceDashboardComponent } from './modules/cpp/cpp-error-order-maintenance-dashboard/cpp-error-order-maintenance-dashboard.component';
import { LicensingDashboardComponent } from './modules/seed/licensing/licensing-dashboard/licensing-dashboard.component';
import { AddUpdateLicenseComponent } from './modules/seed/licensing/add-update-license/add-update-license.component';
import { AddUpdateLicenseSliderModelService } from './modules/seed/licensing/add-update-license/add-update-license-slider-model.service';
import { CppPriceListDashboardComponent } from './modules/cpp/cpp-price-list-dashboard/cpp-price-list-dashboard.component';
import { CppCustomerPriceListComponent } from './modules/cpp/cpp-customer-price-list/cpp-customer-price-list.component';
import { SeedReturnsSoybeanDashboardComponent } from './modules/seed/seed-returns-soybean/seed-returns-soybean-dashboard/seed-returns-soybean-dashboard.component';
import { SeedReturnsSoybeanCreateEditComponent } from './modules/seed/seed-returns-soybean/create-edit-request/seed-returns-soybean-create-edit.component';
import { SeedReturnAddProductComponent } from './common/components//seed-return-add-product/seed-return-add-product.component';
import { SeedReturnAddProductSliderModelService } from './common/components/seed-return-add-product/seed-return-product-slider-model.service';
import { CropEdgeAccountListDialogComponent } from './modules/partnerwebsite/crop-edge-account-dialog/crop-edge-account-dialog.component';
import { SubstitutionOrderReportComponent } from './modules/seed/report/substitution-order-report/substitution-order-report.component';
import { CppPricelistManageSubscriptionComponent } from './modules/cpp/cpp-pricelist-manage-subscription/cpp-pricelist-manage-subscription.component';
import { OtiOrderSummaryComponent } from './modules/oti/oti-order-summary/oti-order-summary.component';
import { OtiService } from './services/oti/oti.service';
import { OtiGridViewComponent } from './modules/oti/oti-grid-view/oti-grid-view.component';
import { ViewQuoteOrderComponent } from './modules/quote-order/view-quote-order/view-quote-order.component';
import { ViewQuoteDetailsComponent } from './modules/quote-order/view-quote-details/view-quote-details.component';
import { CreateQuoteOrderComponent } from './modules/quote-order/create-quote-order/create-quote-order.component';
import { QuoteOrderSummaryComponent } from './modules/quote-order/quote-order-summary/quote-order-summary.component';
import { QuoteOrderService } from './services/quote-order/quote-order.service';
import { QuoteOrderSummaryGridComponent } from './modules/quote-order/quote-order-summary-grid/quote-order-summary-grid.component';
import { SeedReturnsDashboardComponent } from './modules/seed/seed-returns/seed-returns-dashboard/seed-returns-dashboard.component';
import { SeedReturnsCreateEditComponent } from './modules/seed/seed-returns/seed-returns-create-edit/seed-returns-create-edit.component';
import { SeedReturnsReviewComponent } from './modules/seed/seed-returns/seed-returns-review/seed-returns-review.component';
import { ProductLineDeliveryInstructionsComponent } from './common/components/product-line-delivery-instructions/product-line-delivery-instructions.component';
import { ProductLineDeliveryInstructionSliderModelService } from './common/components/product-line-delivery-instructions/product-line-delivery-instructions-slider-model.service';
import { SeedFulfillmentBreakdownViewEditComponent } from './common/components/seed-fulfillment-breakdown-view-edit/seed-fulfillment-breakdown-view-edit.component';
import { SeedFulfillmentViewEditBreakdownSliderModelService } from './common/components/seed-fulfillment-breakdown-view-edit/seed-fulfillment-breakdown-view-edit-slider-model.service';
import { SeedReturnsConfirmationComponent } from './modules/seed/seed-returns/seed-returns-confirmation/seed-returns-confirmation.component';
import { ThreeDigitDecimaNumberDirective } from './common/directive/three-digit-decima-number.directive';
import { FourDigitDecimaNumberDirective } from './common/directive/four-digit-decimal-number.directive';
import { CreateBlanketOrderComponent } from './modules/blanket-order/create-blanket-order/create-blanket-order.component';
import { BlanketOrderSummaryComponent } from './modules/blanket-order/blanket-order-summary/blanket-order-summary.component';
import { AddProductComponent } from './modules/blanket-order/add-product/add-product.component';
import { BlanketOrderGridComponent } from './modules/blanket-order/blanket-order-grid/blanket-order-grid.component';
import { BlanketOrderService } from './services/blanket-order/blanket-order.service';
import { BlanketAddProductSliderModelService } from './modules/blanket-order/add-product/blanket-add-product-slider-model.service';
import { UploadProductComponent } from './modules/blanket-order/upload-product/upload-product.component';
import { BlanketGridViewComponent } from './modules/blanket-order/blanket-grid-view/blanket-grid-view.component';
import { UploadAddProductComponent } from './modules/blanket-order/upload-add-product/upload-add-product.component';
import { CppReturnsDashboardComponent } from './modules/cpp-returns/cpp-returns-dashboard/cpp-returns-dashboard.component';
import { CppReturnsCreateEditComponent } from './modules/cpp-returns/cpp-returns-create-edit/cpp-returns-create-edit.component';
import { CppReturnsReviewComponent } from './modules/cpp-returns/cpp-returns-review/cpp-returns-review.component';
import { CppReturnsConfirmationComponent } from './modules/cpp-returns/cpp-returns-confirmation/cpp-returns-confirmation.component';
import { CppReturnsService } from './services/cpp-returns/cpp-returns.service';
import { CppReturnAddProductComponent } from './common/components/cpp-return-add-product/cpp-return-add-product.component';
import { CppReturnAddProductSliderModelService } from './common/components/cpp-return-add-product/cpp-return-product-slider-model.service';
import { CppReturnFilterComponent } from './common/components/cpp-return-filter/cpp-return-filter.component';
import { FilterComponent } from './common/components/filter/filter.component';
import { CppCoiLandingComponent } from './modules/cpp-coi/cpp-coi-landing/cpp-coi-landing.component';
import { CppCoiRequestEntryComponent } from './modules/cpp-coi/cpp-coi-request-entry/cpp-coi-request-entry.component';
import { CppCoiAddProductComponent } from './modules/cpp-coi/cpp-coi-add-product/cpp-coi-add-product.component';
import { CppCoiRequestConfirmationComponent } from './modules/cpp-coi/cpp-coi-request-confirmation/cpp-coi-request-confirmation.component';
import { CppCoiAddProductSliderModelService } from './modules/cpp-coi/cpp-coi-add-product/cpp-coi-add-product-slider-model.service';
import { CppCoiRequestFilterComponent } from './modules/cpp-coi/cpp-coi-request-filter/cpp-coi-request-filter.component';
import { CppCoiRequestService } from './services/cpp-coi-request/cpp-coi-request.service';
import { CppCoiGridViewComponent } from './modules/cpp-coi/cpp-coi-grid-view/cpp-coi-grid-view.component';
import { SeedCropLossLandingComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-landing/seed-crop-loss-landing.component';
import { SeedCropLossRequestEntryComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-request-entry/seed-crop-loss-request-entry.component';
import { SeedCropLossAddProductComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-add-product/seed-crop-loss-add-product.component';
import { SeedCropLossReviewComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-review/seed-crop-loss-review.component';
import { SeedReplantLandingComponent } from './modules/seed/seed-replant/seed-replant-landing/seed-replant-landing.component';
import { SeedReplantRequestEntryComponent } from './modules/seed/seed-replant/seed-replant-request-entry/seed-replant-request-entry.component';
import { SeedReplantAddOriginalProductComponent } from './modules/seed/seed-replant/seed-replant-add-original-product/seed-replant-add-original-product.component';
import { SeedReplantAddReplantProductComponent } from './modules/seed/seed-replant/seed-replant-add-replant-product/seed-replant-add-replant-product.component';
import { SeedReplantReviewComponent } from './modules/seed/seed-replant/seed-replant-review/seed-replant-review.component';
import { SeedReplantAddOriginalProductSliderModelService } from './modules/seed/seed-replant/seed-replant-add-original-product/seed-replant-add-original-product-slider-model.service';
import { SeedReplantAddReplantProductSliderModelService } from './modules/seed/seed-replant/seed-replant-add-replant-product/seed-replant-add-replant-product-slider-model.service';
import { SeedCropLossAddProductSliderModelService } from './modules/seed/seed-crop-loss/seed-crop-loss-add-product/seed-crop-loss-add-product-slider-model.service';
import { SeedReplantService } from './services/seed/seed-replant/seed-replant.service';
import { StockTransferLandingComponent } from './modules/seed/sot/sot-landing/sot-landing.component';
import { StockTransferRequestEntryComponent } from './modules/seed/sot/sot-request-entry/sot-request-entry.component';
import { StockTransferAddProductComponent } from './modules/seed/sot/sot-add-product/sot-add-product.component';
import { StockTransferSelectAccountComponent } from './modules/seed/sot/sot-select-account/sot-select-account.component';
import { StockTransferApproveRejectComponent } from './modules/seed/sot/sot-approve-reject/sot-approve-reject.component';
import { StockTransferAddProductSliderModelService } from './modules/seed/sot/sot-add-product/sot-add-product.component-slider-model.service';
import { StockRequestHistorySliderModelService } from './modules/seed/sot/sot-request-history/sot-request-history.component-slider-model.service';
import { StockTransferSelectAccountSliderModelService } from './modules/seed/sot/sot-select-account/sot-select-account.component-slider-model.service';
import { gridViewComponent } from './common/components/grid-view/grid-view.component';
import { SotRequestHistoryComponent } from './modules/seed/sot/sot-request-history/sot-request-history.component';
// import { AgmCoreModule } from '@agm/core';
import { ShippingAvailabilityComponent } from './modules/seed/report/shipping-availability/shipping-availability.component';
import { DeliveryInstructionService } from './services/seed/delivery-Instruction.service';
import { LandingDeliveryInstructionsComponent } from './modules/seed/fullfillment/delivery-instructions/delivery-instructions-landing/delivery-instructions-landing.component';
import { CreateEditDeliveryInstructionsComponent } from './modules/seed/fullfillment/delivery-instructions/delivery-instructions-create-edit/create-edit-delivery-Instructions.component';
import { ContainerReturnsDashboardComponent } from './modules/container-returns/container-returns-dashboard/container-returns-dashboard.component';
import { ContainerReturnsAddEditComponent } from './modules/container-returns/container-returns-add-edit/container-returns-add-edit.component';
import { ContainerReturnsAddProductComponent } from './modules/container-returns/container-returns-add-product/container-returns-add-product.component';
import { ContainerReturnService } from './services/container-return/container-return.service';
import { ContainerReturnsAddProductSliderModelService } from './modules/container-returns/container-returns-add-product/container-returns-add-product-slider-model.service';
import { ContainerReturnsReviewComponent } from './modules/container-returns/container-returns-review/container-returns-review.component';
import { ContainerReturnsConfirmationComponent } from './modules/container-returns/container-returns-confirmation/container-returns-confirmation.component';
import { DealerOrderInternalTransferComponent } from './common/components/dealer-order-internal-transfer/dealer-order-internal-transfer.component';
import { InternalTransferSelectAccountComponent } from './common/components/dealer-order-internal-transfer/internal-transfer-select-account/internal-transfer-select-account.component';
import { CalendarMonthYearComponent } from './common/components/calendar-month-year/calendar-month-year.component';
import { CppSraCostSheetRetailComponent } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-retail/cpp-sra-cost-sheet-retail.component';
import { CppSraCostSheetPriceSimulationComponent } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-price-simulation/cpp-sra-cost-sheet-price-simulation.component';
import { DropdownMultiselectComponent } from './common/components/dropdown-multiselect/dropdown-multiselect.component';
import { CppSraCostSheetGlossaryComponent } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-glossary/cpp-sra-cost-sheet-glossary.component';
import { CppAMSPricingComponent } from './modules/cpp/reports/cpp-ams-pricing/cpp-ams-pricing.component';
import { CppSulfurZincPricingComponent } from './modules/cpp/reports/cpp-sulfur-zinc-pricing/cpp-sulfur-zinc-pricing.component';
import { CppAmsPricingManageSubscriptionComponent } from './modules/cpp/reports/cpp-ams-pricing-manage-subscription/cpp-ams-pricing-manage-subscription.component';
import { CppSulfurZincPricingManageSubscriptionComponent } from './modules/cpp/reports/cpp-sulfur-zinc-pricing-manage-subscription/cpp-sulfur-zinc-pricing-manage-subscription.component';
import { EverydayLowPriceListComponent } from './modules/cpp/reports/everyday-low-price-list/everyday-low-price-list.component';
import { CppReportService } from './services/cpp/cpp-report.service';
import { EdlpService } from './services/cpp/edlp.service';
import { SubscriptionLandingPageComponent } from './modules/subscription-management/subscription-landing-page/subscription-landing-page.component';
import { MySubscriptionsComponentComponent } from './modules/subscription-management/my-subscriptions-component/my-subscriptions-component.component';
import { ManageSubscriptionsComponentComponent } from './modules/subscription-management/manage-subscriptions-component/manage-subscriptions-component.component';
import { GlobalSubscriptionDialogComponent } from './modules/subscription-management/global-subscripton-dialog/global-subscripton-dialog.component';
import { CppLandingDeliveryInstructionsComponent } from './modules/cpp/cpp-delivery-instructions/cpp-delivery-instructions-landing/cpp-delivery-instructions-landing.component';
import { CppCreateEditDeliveryInstructionsComponent } from './modules/cpp/cpp-delivery-instructions/cpp-delivery-instructions-create-edit/cpp-create-edit-delivery-Instructions.component';
import { CppDeliveryInstructionService } from './services/cpp/cpp-delivery-instruction.service';
import { CppUserListLandingComponent } from './modules/cpp/cpp-user-list/cpp-user-list-landing/cpp-user-list-landing.component';
import { CppUserListCreateEditComponent } from './modules/cpp/cpp-user-list/cpp-user-list-create-edit/cpp-create-edit-user-list.component';
import { CppUserListService } from './services/cpp/cpp-user-list.service';
import { LolLoggerService } from './common/shared/lol-logger.service';
import { SeedReturnsApproveRejectComponent } from './modules/seed/seed-returns/seed-returns-approve-reject/seed-returns-approve-reject.component';
import { CppReturnsApproveRejectComponent } from './modules/cpp-returns/cpp-returns-approve-reject/cpp-returns-approve-reject.component';
import { SeedReturnsSoybeanZeroDumpsComponent } from './modules/seed/seed-returns-soybean/seed-returns-soybean-zero-dumps/seed-returns-soybean-zero-dumps.component';
import { UserReportFilterComponent } from './common/components/user-report-filter/user-report-filter.component';
import { UserReportFilterSliderService } from './common/components/user-report-filter/user-report-filter-slider.service';
import { ColumnSelectorComponent } from './common/components/column-selector/column-selector.component';
import { UserReportFilterService } from './services/seed/reports/user-report-filter.service';
import { EaSwapProductComponent } from './modules/seed/order/ea-order/ea-swap-product/ea-swap-product.component';
import { EaAddProductComponent } from './modules/seed/order/ea-order/ea-add-product/ea-add-product.component';
import { EaProductModifyDecreaseUnitComponent } from './modules/seed/order/ea-order/ea-product-modify-decrease-unit/ea-product-modify-decrease-unit.component';
import { EaSwapProductSliderModelService } from './modules/seed/order/ea-order/ea-swap-product/ea-swap-product-slider-model.service';
import { EaAddProductSliderModelService } from './modules/seed/order/ea-order/ea-add-product/ea-add-product-slider-model.service';
import { EaProductModifyDecreaseUnitSliderModelService } from './modules/seed/order/ea-order/ea-product-modify-decrease-unit/ea-product-modify-decrease-unit-slider-model.service';
import { AnalogClockComponent } from './common/components/analog-clock/analog-clock.component';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GrowerProgramDashboardComponent } from './modules/grower-program/grower-program-dashboard/grower-program-dashboard.component'
import { GrowerProgramService } from './services/seed/growerProgram.service';
import { GrowerProgramImportComponent } from './modules/grower-program/grower-program-import/grower-program-import.component';
import { GrowerProgramBudgetComponent } from './modules/grower-program/grower-program-budget/grower-program-budget.component';
import { RetailerSearchComponent } from './modules/grower-program/retailer-search/retailer-search.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { GrowerProgramNameComponent } from './modules/grower-program/grower-program-name/grower-program-name.component';
import { AutoSaveDynamicTimerComponent } from './common/components/auto-save-dynamic-timer/auto-save-dynamic-timer.component';
import { GrowerProgramCommentComponent } from './modules/grower-program/grower-program-comment/grower-program-comment.component';
// export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TypeaheadComponent } from './common/components/typeahead/typeahead.component';
import { OtiOrderLandingComponent } from './modules/oti/oti-order-landing/oti-order-landing.component';
import { OtiOrderDetailComponent } from './modules/oti/oti-order-detail/oti-order-detail.component';
import { OtiOrderDetailSliderModelService } from './modules/oti/oti-order-detail/oti-order-detail-slider-model.service';
import { GrowerPdfGenerate } from './modules/seed/order/grower/grower-pdf-generate/grower-pdf-generate.component';
import { ProductLabelLandingComponent } from './modules/cpp/cpp-product-label-orders/product-label-landing/product-label-landing.component';
import { SeedDiscretionaryDashboardComponent } from './modules/grower-program/seed-discretionary-dashboard/seed-discretionary-dashboard.component';
import { CommandCenterComponent } from './modules/command-center/cc-landing/cc-landing.component';
import { CcMessageCenterComponent } from './modules/command-center/cc-message-center/cc-message-center.component';
import { CcKnowledgeCenterComponent } from './modules/command-center/cc-knowledge-center/cc-knowledge-center.component';
import { OtiHomeGridViewComponent } from './modules/oti/oti-home-grid-view/oti-home-grid-view.component';
import { CommandCenterService } from './services/command-center/command-center.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CppProductLabelFormComponent } from './modules/cpp/cpp-product-label-orders/cpp-product-label-form/cpp-product-label-form.component';
import { CppMarketingProgramDashboardComponent } from './modules/cpp-marketing-program/marketing-program-landing/cpp-marketing-program-dashboard.component';
import { CppMarketingProgramGridViewComponent } from './modules/cpp-marketing-program/marketing-program-grid-view/cpp-marketing-program-grid-view.component';
import { CppMarketingProgramTileViewComponent } from './modules/cpp-marketing-program/marketing-program-tile-view/cpp-marketing-program-tile-view.component';
import { SraOrdersLandingComponent } from './modules/cpp/sra-orders/sra-orders-landing/sra-orders-landing.component';
import { SraOrdersService } from './services/cpp/sra-orders.service';
import { SraCreateOrderComponent } from './modules/cpp/sra-orders/sra-create-order/sra-create-order.component';
import { CppSraAddProductSliderModelService } from './modules/cpp/sra-orders/cpp-sra-add-product/cpp-sra-add-product-slider-model.service';
import { CppSraAddProductComponent } from './modules/cpp/sra-orders/cpp-sra-add-product/cpp-sra-add-product.component';
import { SraOrdersAprroveReviewComponent } from './modules/cpp/sra-orders/sra-orders-approve-review/sra-orders-approve-review.component';
import { SraRequestDetailsComponent } from './modules/cpp/sra-orders/sra-request-details/sra-request-details.component';
import { CppSraExistingOrderComponent } from './modules/cpp/sra-orders/cpp-sra-existing-order/cpp-sra-existing-order.component';
import { SraErrorOrderMaintenanceDashboardComponent } from './modules/cpp/sra-orders/sra-error-order-maintenance-dashboard/sra-error-order-maintenance-dashboard.component';
import { SraErrorOrderMaintenanceComponent } from './modules/cpp/sra-orders/sra-error-order-maintenance/sra-error-order-maintenance.component';
import { SeedReservationLandingComponent } from './modules/seed/seed-reservation/seed-reservation-landing/seed-reservation-landing.component';
import { SeedReservationService } from './services/seed/seed-reservation.service';
import { SeedReservationCreateComponent } from './modules/seed/seed-reservation/seed-reservation-create/seed-reservation-create.component';
import { SeedReservationConfirmationComponent } from './modules/seed/seed-reservation/seed-reservation-confirmation/seed-reservation-confirmation.component';
import { OtiAdvancedSearchComponent } from './modules/oti/oti-advanced-search/oti-advanced-search.component'

import { AssociateCropLandingComponent } from './modules/seed/associate-crop/associate-crop-landing/associate-crop-landing.component';
import { AssociateCropCreateOrderComponent } from './modules/seed/associate-crop/associate-crop-create-order/associate-crop-create-order.component';
import { AssociateCropSummaryComponent } from './modules/seed/associate-crop/associate-crop-summary/associate-crop-summary.component';
import { PlotSeedLandingComponent } from './modules/seed/plot-seed/plot-seed-landing/plot-seed-landing.component';
import { PlotSeedCreateOrderComponent } from './modules/seed/plot-seed/plot-seed-create-order/plot-seed-create-order.component';
import { PlotSeedSummaryComponent } from './modules/seed/plot-seed/plot-seed-summary/plot-seed-summary.component';
import { PlotSeedService } from './services/seed/plot-seed.service';
import { PlotSeedReleaseService } from './services/seed/plot-seed-release.service';
import { CppPriceListLookupGridComponent } from './modules/cpp/cpp-price-list-lookup-grid/cpp-price-list-lookup-grid.component';
import { PlotSeedReleaseLandingComponent } from './modules/seed/plot-seed/plot-seed-release-landing/plot-seed-release-landing.component';
import { PlotSeedReleaseReviewComponent } from './modules/seed/plot-seed/plot-seed-release-review/plot-seed-release-review.component';
import { PlotSeedReleaseOrderComponent } from './modules/seed/plot-seed/plot-seed-release-order/plot-seed-release-order.component';
import { PlotSeedReleaseBreakdownViewSliderModelService } from './modules/seed/plot-seed/plot-seed-release-breakdown-view/plot-seed-release-breakdown-view-slider-model.service';
import { PlotSeedReleaseBreakdownViewComponent } from './modules/seed/plot-seed/plot-seed-release-breakdown-view/plot-seed-release-breakdown-view.component';

import { AssociateCropReconciliationLandingComponent } from './modules/seed/associate-crop/associate-crop-reconciliation-landing/associate-crop-reconciliation-landing.component';
import { AddReconcileVarietyComponent } from './modules/seed/associate-crop/add-reconcile-variety/add-reconcile-variety.component';
import { AssociateCropReconciliationConfirmationComponent } from './modules/seed/associate-crop/associate-crop-reconciliation-confirmation/associate-crop-reconciliation-confirmation.component';
import { AssociateCropInventoryComponent } from './modules/seed/associate-crop/associate-crop-inventory/associate-crop-inventory.component';
import { SeedReservationReconcileCreateComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-create/seed-reservation-reconcile-create.component';
import { SeedReservationReconcileAddProductComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-add-product/seed-reservation-reconcile-add-product.component';
import { SeedReservationReconcileGrowerOrderComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-grower-order/seed-reservation-reconcile-grower-order.component';
import { SeedReservationGrowerEditOrder } from './modules/seed/seed-reservation/seed-reservation-grower-edit-order/seed-reservation-grower-edit-order.component';
import { SeedReservationReconciliationService } from './services/seed/seed-reservation-reconciliation.service';
import { SeedReservationReconcileAddHybridProductComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-add-hybrid-product/seed-reservation-reconcile-add-hybrid-product.component';
import { GrowerOrderAddHybridProductComponent } from './modules/seed/order/grower/grower-order-add-hybrid-product/grower-order-add-hybrid-product.component';

import { AiChatbotComponent } from './common/components/ai-chatbot/ai-chatbot.component';
import { AiCppChatbotComponent } from './common/components/ai-cpp-chatbot/ai-cpp-chatbot.component';
@NgModule({ declarations: [
        AppComponent,
        LandingDataComponent,
        OrderViewComponent,
        GrowerOrderAddComponent,
        GrowerOrderDetailComponent,
        ProductAddComponent,
        ConfirmDialogComponent,
        // PositiveValue,
        DealerOrderViewComponent,
        AddEditOrderDetailComponent,
        ProductChangeComponent,
        NumberOnlyDirective,
        GrowerOrderTransferComponent,
        DealerOrderTransferComponent,
        UserSecurityComponent,
        efulfillmentTableComponent,
        efulfillmentfilterComponent,
        CreateEditSeedFulfillmentComponent,
        LandingSeedFulfillmentComponent,
        GrowerLandingComponent,
        GrowerSearchComponent,
        GrowerAddComponent,
        LogoutComponent,
        UnAuthorizeComponent,
        ItemAvailabilityComponent,
        QuickOrderSearchComponent,
        ReportDashboardComponent,
        ItemAvailabilityDetailComponent,
        GrowerOrderAuditComponent,
        DealerOrderAuditComponent,
        DialogComponent,
        EmulationDashboardComponent,
        TotalOrderSummaryComponent,
        NewPrePayRequestComponent,
        PrepayContractComponent,
        PrepayLandingComponent,
        EditPrePayRequestComponent,
        CustomCurrencyPipe,
        customCurrencyDirective,
        DiffDealerGrowerOrderTransferComponent,
        DecimalNumberDirective,
        ShippableProductsReportComponent,
        ReleaseItemsAuditComponent,
        CppLandingComponent,
        CppCreateOrderComponent,
        CPPFilterComponent,
        CppAddProductComponent,
        CppOrderSummaryComponent,
        CppGridViewComponent,
        CppErrorOrderMaintenanceDashboardComponent,
        CppErrorOrderMaintenanceComponent,
        CppBusinessRuleAnalysisDialogComponent,
        LicensingDashboardComponent,
        AddUpdateLicenseComponent,
        CppPriceListDashboardComponent,
        CppCustomerPriceListComponent,
        SeedReturnsSoybeanDashboardComponent,
        SeedReturnAddProductComponent,
        SeedReturnsSoybeanCreateEditComponent,
        SeedReturnFilterComponent,
        CropEdgeAccountListDialogComponent,
        SubstitutionOrderReportComponent,
        CppPricelistManageSubscriptionComponent,
        OtiOrderSummaryComponent,
        OtiGridViewComponent,
        ViewQuoteOrderComponent,
        ViewQuoteDetailsComponent,
        CreateQuoteOrderComponent,
        QuoteOrderSummaryComponent,
        QuoteOrderSummaryGridComponent,
        SeedReturnsDashboardComponent,
        SeedReturnsCreateEditComponent,
        SeedReturnsReviewComponent,
        SeedReturnsConfirmationComponent,
        ThreeDigitDecimaNumberDirective,
        FourDigitDecimaNumberDirective,
        CreateBlanketOrderComponent,
        BlanketOrderSummaryComponent,
        AddProductComponent,
        BlanketOrderGridComponent,
        UploadProductComponent,
        UploadAddProductComponent,
        BlanketGridViewComponent,
        CppReturnsDashboardComponent,
        CppReturnsCreateEditComponent,
        CppReturnsReviewComponent,
        CppReturnsConfirmationComponent,
        CppReturnAddProductComponent,
        CppReturnFilterComponent,
        FilterComponent,
        CppCoiLandingComponent,
        CppCoiRequestEntryComponent,
        CppCoiAddProductComponent,
        CppCoiRequestConfirmationComponent,
        CppCoiRequestFilterComponent,
        CppCoiGridViewComponent,
        SeedCropLossLandingComponent,
        SeedCropLossRequestEntryComponent,
        SeedCropLossAddProductComponent,
        SeedCropLossReviewComponent,
        SeedReplantLandingComponent,
        SeedReplantRequestEntryComponent,
        SeedReplantAddOriginalProductComponent,
        SeedReplantAddReplantProductComponent,
        SeedReplantReviewComponent,
        StockTransferLandingComponent,
        StockTransferRequestEntryComponent,
        StockTransferAddProductComponent,
        StockTransferSelectAccountComponent,
        StockTransferApproveRejectComponent,
        StockTransferRequestEntryComponent,
        gridViewComponent,
        SotRequestHistoryComponent,
        LandingDeliveryInstructionsComponent,
        CreateEditDeliveryInstructionsComponent,
        DealerOrderInternalTransferComponent,
        InternalTransferSelectAccountComponent,
        SotRequestHistoryComponent,
        ContainerReturnsDashboardComponent,
        ContainerReturnsAddEditComponent,
        ContainerReturnsAddProductComponent,
        ContainerReturnsReviewComponent,
        ContainerReturnsConfirmationComponent,
        InternalTransferSelectAccountComponent,
        ProductLineDeliveryInstructionsComponent,
        SeedFulfillmentBreakdownViewEditComponent,
        ShippingAvailabilityComponent,
        CppSraCostSheetRetailComponent,
        CppSraCostSheetPriceSimulationComponent,
        DropdownMultiselectComponent,
        CppSraCostSheetGlossaryComponent,
        CppAMSPricingComponent,
        CppSulfurZincPricingComponent,
        CppAmsPricingManageSubscriptionComponent,
        CppSulfurZincPricingManageSubscriptionComponent,
        CppSulfurZincPricingComponent,
        EverydayLowPriceListComponent,
        ShippingAvailabilityComponent,
        CalendarMonthYearComponent,
        SubscriptionLandingPageComponent,
        MySubscriptionsComponentComponent,
        ManageSubscriptionsComponentComponent,
        GlobalSubscriptionDialogComponent,
        CppLandingDeliveryInstructionsComponent,
        CppCreateEditDeliveryInstructionsComponent,
        CppUserListLandingComponent,
        CppUserListCreateEditComponent,
        SeedReturnsApproveRejectComponent,
        CppReturnsApproveRejectComponent,
        SeedReturnsSoybeanZeroDumpsComponent,
        UserReportFilterComponent,
        ColumnSelectorComponent,
        EaSwapProductComponent,
        EaAddProductComponent,
        EaProductModifyDecreaseUnitComponent,
        AnalogClockComponent,
        GrowerProgramDashboardComponent,
        GrowerProgramImportComponent,
        GrowerProgramBudgetComponent,
        RetailerSearchComponent,
        GrowerProgramNameComponent,
        AutoSaveDynamicTimerComponent,
        AutoSaveDynamicTimerComponent,
        GrowerProgramCommentComponent,
        TypeaheadComponent,
        OtiOrderLandingComponent,
        OtiOrderDetailComponent,
        GrowerPdfGenerate,
        SeedDiscretionaryDashboardComponent,
        CommandCenterComponent,
        CcMessageCenterComponent,
        OtiHomeGridViewComponent,
        ProductLabelLandingComponent,
        CppProductLabelFormComponent,
        CcKnowledgeCenterComponent,
        CppMarketingProgramDashboardComponent,
        CppMarketingProgramGridViewComponent,
        CppMarketingProgramTileViewComponent,
        SraOrdersLandingComponent,
        SraCreateOrderComponent,
        CppSraAddProductComponent,
        SraOrdersAprroveReviewComponent,
        SraRequestDetailsComponent,
        CppSraExistingOrderComponent,
        SraErrorOrderMaintenanceDashboardComponent,
        SraErrorOrderMaintenanceComponent,
        SeedReservationLandingComponent,
        SeedReservationCreateComponent,
        SeedReservationConfirmationComponent,
        OtiAdvancedSearchComponent,
        AssociateCropLandingComponent,
        AssociateCropCreateOrderComponent,
        AssociateCropSummaryComponent,
        PlotSeedLandingComponent,
        PlotSeedCreateOrderComponent,
        PlotSeedSummaryComponent,
        CppPriceListLookupGridComponent,
        AssociateCropReconciliationLandingComponent,
        AddReconcileVarietyComponent,
        AssociateCropReconciliationConfirmationComponent,
        AssociateCropInventoryComponent,
        PlotSeedReleaseLandingComponent,
        PlotSeedReleaseOrderComponent,
        PlotSeedReleaseBreakdownViewComponent,
        PlotSeedReleaseReviewComponent,
        SeedReservationReconcileCreateComponent,
        SeedReservationReconcileAddProductComponent,
        SeedReservationReconcileGrowerOrderComponent,
        SeedReservationGrowerEditOrder,
        SeedReservationReconcileAddHybridProductComponent,
        GrowerOrderAddHybridProductComponent,
        AiChatbotComponent,
        AiCppChatbotComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }) as ModuleWithProviders<BrowserModule>,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        NgIdleModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        NgSelectModule,
        ClickOutSideModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        CurrencyMaskModule,
        NgxMaskDirective,
        NgxMaskPipe,
        // AgmCoreModule.forRoot({
        //   apiKey: 'AIzaSyBzNACwdOs5KDaElu85vIM1Eo68awpa8H4'
        // }),
        ToastrModule.forRoot()], providers: [ConfigService,
        SharedDataService,
        CookieService,
        NetworkService,
        DashboardService,
        BroadcastService,
        GrowerOrderService,
        DealerService,
        LoaderService,
        SliderModelService,
        CommonService,
        LocalStorageService,
        OrderTransferService,
        UserSecurityService,
        ExcelService,
        SeedFulfillmentService,
        LineItemAvailabilityService,
        GrowerDealerAuditService,
        TotalOrderSummaryService,
        PrePayService,
        CppService,
        CppPriceListService,
        CppManageSubscription,
        CppReturnsService,
        ReleaseItemsAuditService,
        DatePipe,
        CurrencyPipe,
        CustomCurrencyPipe,
        CppAddProductSliderModelService,
        LicensingService,
        AddUpdateLicenseSliderModelService,
        SeedReturnAddProductSliderModelService,
        SeedReturnService,
        OtiService,
        QuoteOrderService,
        BlanketOrderService,
        BlanketAddProductSliderModelService,
        CppReturnAddProductSliderModelService,
        CppCoiAddProductSliderModelService,
        CppCoiRequestService,
        SeedReplantAddOriginalProductSliderModelService,
        SeedReplantAddReplantProductSliderModelService,
        SeedCropLossAddProductSliderModelService,
        SeedCropLossService,
        SeedReplantService,
        StockTransferAddProductSliderModelService,
        StockTransferSelectAccountSliderModelService,
        StockRequestHistorySliderModelService,
        DeliveryInstructionService,
        ProductLineDeliveryInstructionSliderModelService,
        SeedFulfillmentViewEditBreakdownSliderModelService,
        PlotSeedReleaseBreakdownViewSliderModelService,
        CppReportService,
        EdlpService,
        ProductLineDeliveryInstructionSliderModelService,
        ContainerReturnsAddProductSliderModelService,
        CppReportService,
        SubscriptionManagementService,
        CppDeliveryInstructionService,
        CppUserListService,
        LolLoggerService,
        UserReportFilterService,
        UserReportFilterSliderService,
        EaSwapProductSliderModelService,
        EaAddProductSliderModelService,
        EaProductModifyDecreaseUnitSliderModelService,
        GrowerProgramService,
        SliderModelService,
        CppPricingReportManageSubscription,
        OtiOrderDetailSliderModelService,
        CommandCenterService,
        SraOrdersService,
        CppSraAddProductSliderModelService,
        SeedReservationService,
        AssociateCropService,
        PlotSeedService,
      PlotSeedReleaseService,
      SeedReservationReconciliationService,
        provideNgxMask(), provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
